import { apiAuth, apiResponseType } from ".";

export const getRevenueCategoriesData = (page: number = 1): apiResponseType =>
  apiAuth.get(`revenue-categories?page=${page}`);

export const selectRevenueCategoriesData = (): apiResponseType =>
  apiAuth.get(`revenue-categories/select`);

export const searchRevenueCategoriesData = (params: { name: string }): apiResponseType =>
  apiAuth.get(`revenue-categories?name=${params.name}`);

export const storeRevenueCategoryData = (data: {
  name: string;
  description?: string;
}) => apiAuth.post("revenue-categories/store", data) as apiResponseType;

export const updateRevenueCategoryData = (uuid: string, data: {
  name: string;
  description?: string;
}) =>
  apiAuth.put(`revenue-categories/${uuid}/update`, data) as apiResponseType;

export const deleteRevenueCategoryData = (uuid: string) =>
  apiAuth.delete(`revenue-categories/${uuid}/destroy`) as apiResponseType;

export const getShowRevenueCategory = (uuid: string) =>
  apiAuth.get(`revenue-categories/${uuid}/show`) as apiResponseType; 